import React, { useRef, useCallback, useEffect, memo } from 'react';
import Moment from 'react-moment';
import Bounce from 'react-reveal/Bounce';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import _ from 'lodash';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';

// import UserBox from 'components/UserBox';
// import CardArrow from 'features/discuss/components/_CardArrow';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    overflow: 'visible',
    // minWidth: 235,
  },
    colors: {
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[100],
    },
    bordered: {
      border: `3px solid ${theme.palette.secondary.main}`,
      borderRadius: 4, // @todo take it from theme
    },
  arrow: {
    // border: 'solid black 1px', // DEBUG
    position: 'absolute', top: 10,
    overflow: 'hidden',
    width: 12, height: 20,
    '& > span': {
      display: 'block',
      position: 'absolute', top: 0,
      width: 20, height: 20,
      transform: 'rotate(45deg)',
    },
  },
    arrowLeft: {
      left: '100%',
      '& > span': { right: '50%' },
    },
    arrowRight: {
      right: '100%',
      '& > span': { left: '50%' },
    },
  content: {
    padding: 10, // @todo find the proper card padding
  },
    header: {
      display: 'flex',
      marginBottom: 5,
      '& > div': {
        lineHeight: '22px',
        fontSize: '10px',
      },
    },
      user: {
        // borderRadius: '7px',
        // backgroundColor: 'rgb(250, 67, 41)',
        // padding: '0px 5px',
        // fontWeight: 'bold',
        // color: 'white',
      },
      date: {},
  actionbar: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'right',
    '& > *': { display: 'inline-flex' }
  },
  actionbarColors: {
    color: theme.palette.grey[600],
  },
  filler: { flex: '1 1 auto' },
  invert: { flexDirection: 'row-reverse' },
}));

const getText = (entity) => {
  return _.has(entity, 'title') ? entity.title : entity.text;
};

function ClaimCard(props) {
  const {
    classes,
    className,
    side,
    focused, onFocus,
    bounced,
    owner,
    parent,
    entity,
    reflect,
    actionPanelLeft,
    actionPanelRight,
  } = props;
  const classesBase = useStyles();
  const _classes = { ...classesBase, ...classes };
  const titleRef = useRef(null);

  const buildHeader = () => (
    <div className={clsx(_classes.header, {
      [_classes.invert]: side === 'right',
    })}>
      <div className={_classes.user}>{owner}</div>
      <div className={_classes.filler}>&nbsp;</div>
      <div className={_classes.date}>
        <Moment fromNow>{entity.metadata.createdDate}</Moment>
      </div>
    </div>
  );

  const buildActionPanel = () => (<>
    <div>
      {actionPanelLeft}
    </div>
    <div className={_classes.filler}>&nbsp;</div>
    <div>
      {actionPanelRight}
    </div>
  </>);

  const Content = () => {
    return entity.media
      ? <div ref={titleRef} className={_classes.media}>
          <audio controls>
            <source src={entity.media} type="audio/webm" />
          </audio>
          {reflect}
        </div>
      : <div ref={titleRef} className={_classes.text}>
          {getText(entity)} {reflect}
        </div>;
  };

  const CardArrow = memo(({ caFocused }) => (
    <div className={clsx(_classes.arrow, {
      [_classes.arrowLeft]: side === 'left',
      [_classes.arrowRight]: side === 'right',
    })}>
      <span className={clsx(_classes.colors, {
        [_classes.bordered]: caFocused,
      })}>&nbsp;</span>
    </div>
  ));

  const cbFocus = useCallback(onFocus, []);
  useEffect(() => {
    if (focused) {
      setTimeout(() => {
        titleRef.current.scrollIntoView({
          behavior: 'smooth',
          // block: 'start',
          block: 'center',
        });
      }, 500);
      setTimeout(() => {
        cbFocus();
      }, 10000);
    }
  }, [focused, cbFocus]);

  // console.log('ClaimCard', props); // DEBUG

  return (
    <Card className={clsx(_classes.root, _classes.colors, className, {
      [_classes.bordered]: focused,
    })}>
      {side && <CardArrow caFocused={focused} />}
      <CardContent className={_classes.content}>
        {buildHeader()}

        {parent}

        {bounced
          ? <Bounce>
              <Content />
            </Bounce>
          : <Content />
        }
      </CardContent>

      <CardActions className={clsx(_classes.actionbar, _classes.actionbarColors)} disableSpacing>
        {buildActionPanel()}
      </CardActions>

    </Card>
  );
}

ClaimCard.propTypes = {
  entity: PropTypes.object.isRequired,
  owner: PropTypes.object.isRequired, // @todo think about this
};

export default ClaimCard;
